export default 0.0251044050155075;
